module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/CaYGc8/tc-custom/9781507201886.jpg?1730520069851",
      "alt": "This image is the cover for the book How to Read Tarot"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("How to Read Tarot\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Learn how to anticipate the future and shape the present in this new guide about reading Tarot cards.")]), _c('br'), _c('br'), _vm._v("For centuries, mystics and clairvoyants have used Tarot cards to predict the future. But no special power is needed to read the cards with "), _c('i', [_vm._v("How to Read Tarot")]), _vm._v(". This easy-to-follow guide can show you how to interpret and understand the meaning behind Tarot cards. You’ll find everything from explanations of each card in the deck to using the Tarot for personal gain. The truth is in the cards—that is, if you know where to look.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Adams Media\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Adams Media, an imprint of Simon & Schuster, informs, instructs, and inspires readers across a variety of lifestyle categories by providing the content they’re looking for, from the experts they follow and trust. From New Age to Personal Finance, Cooking to Self-Help, Adams Media researches, identifies, creates, and distributes accessible content with implicit discoverability. Embodying a uniquely flexible “ground-up” publishing model, Adams Media navigates within or between consumer categories as market opportunity dictates. These are the books people are searching for. ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Adams Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0